import { createContext, useContext, useState } from 'react';

const PageTitleContext = createContext();

export const usePageTitle = () => useContext(PageTitleContext);

export const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('');
  return (
    <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};
